module.exports={render:function (){
var this$1 = this;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "modal"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.show),
      expression: "show"
    }],
    staticClass: "modal-mask"
  }, [_c('div', {
    staticClass: "modal-container"
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_c('h3', [_vm._v("Relatório de Fechamento")])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body",
    attrs: {
      "id": "imp"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12 table-responsive"
  }, [_vm._l((_vm.apiData[0].usuarios), function(usu) {
    return [(usu.consultas.length > 0) ? _c('table', {
      staticClass: "table table-bordered table-striped",
      attrs: {
        "aria-describedby": "example1_info",
        "role": "grid",
        "id": "example1"
      }
    }, [_c('thead', [_c('tr', {
      staticClass: "trHeader"
    }, [_c('td', {
      staticStyle: {
        "padding-bottom": "20px"
      },
      attrs: {
        "colspan": "4"
      }
    }, [_c('table', {
      staticStyle: {
        "width": "100%"
      }
    }, [_c('thead', [_c('tr', [_c('td', {
      staticStyle: {
        "text-align": "left",
        "width": "20%"
      }
    }, [_vm._v("LOGO")]), _vm._v(" "), _c('td', {
      staticStyle: {
        "text-align": "center",
        "width": "60%",
        "font-size": "15px"
      }
    }, [_c('strong', [_vm._v("Relatório de Fechamento")]), _c('br'), _c('small', [_vm._v("(" + _vm._s(_vm.date_format(_vm.apiData[0].periodo_inicial)) + " à " + _vm._s(_vm.date_format(_vm.apiData[0].periodo_final)) + ")")]), _c('br'), _vm._v("\n\n                              " + _vm._s(_vm.apiData[0].fantasia) + " - Usuário: " + _vm._s(usu.login) + "\n                              "), _c('br')]), _vm._v(" "), _c('td', {
      staticStyle: {
        "text-align": "right",
        "width": "20%"
      }
    }, [_vm._v("\n                              Premium Consulta\n                            ")])])])])])]), _vm._v(" "), _c('tr', {
      attrs: {
        "role": "row"
      }
    }, [_c('th', {
      staticStyle: {
        "width": "20%"
      }
    }, [_vm._v("Data")]), _vm._v(" "), _c('th', {
      staticStyle: {
        "width": "30%"
      }
    }, [_vm._v("Tipo de Consulta")]), _vm._v(" "), _c('th', {
      staticStyle: {
        "width": "30%"
      }
    }, [_vm._v("Documento Consultado")]), _vm._v(" "), _c('th', {
      staticStyle: {
        "width": "20%"
      }
    }, [_vm._v("Valor")])])]), _vm._v(" "), _c('tbody', [_vm._l((usu.consultas), function(item) {
      return _c('tr', {
        staticClass: "even",
        attrs: {
          "role": "row"
        }
      }, [_c('td', [_vm._v(_vm._s(_vm.date_format(item.created_at)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.tipo))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.cpf_cnpj))]), _vm._v(" "), _c('td', [_vm._v("R$ " + _vm._s(_vm.number_format(item.valor, 2, ',', '.')))])])
    }), _vm._v(" "), _c('tr', {
      staticClass: "even",
      attrs: {
        "role": "row"
      }
    }, [_c('td', {
      staticStyle: {
        "text-align": "right"
      },
      attrs: {
        "colspan": "3"
      }
    }, [_c('strong', [_vm._v("Subtotal")])]), _vm._v(" "), _c('td', [_c('strong', [_vm._v("R$ " + _vm._s(_vm.subtotal(usu.consultas)))])])])], 2)]) : _vm._e()]
  }), _vm._v(" "), _c('table', {
    staticClass: "table table-bordered table-striped",
    attrs: {
      "aria-describedby": "example1_info",
      "role": "grid",
      "id": "example1"
    }
  }, [_c('thead', [_c('tr', {
    attrs: {
      "role": "row"
    }
  }, [_c('th', {
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "colspan": "3"
    }
  }, [_vm._v("Resumo da Fatura")])]), _vm._v(" "), _c('tr', {
    attrs: {
      "role": "row"
    }
  }, [_c('th', {
    staticStyle: {
      "width": "55%"
    }
  }, [_vm._v("Descrição")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "15%"
    }
  }, [_vm._v("Qtd.")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "30%"
    }
  }, [_vm._v("Valor")])]), _vm._v(" "), _c('tr', {
    attrs: {
      "role": "row"
    }
  }, [_c('td', [_vm._v("Mensalidade")]), _vm._v(" "), _c('td', [_vm._v("---")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.number_format(_vm.apiData[0].mensalidade, 2, ',', '.')))])]), _vm._v(" "), _c('tr', {
    attrs: {
      "role": "row"
    }
  }, [_c('td', [_vm._v("Total. Consultas Restritivas")]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.number_format(_vm.totais.restritiva, 2, ',', '.')))])]), _vm._v(" "), _c('tr', {
    attrs: {
      "role": "row"
    }
  }, [_c('td', [_vm._v("Total. Consultas Analíticas")]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.number_format(_vm.totais.analitica, 2, ',', '.')))])]), _vm._v(" "), _c('tr', {
    attrs: {
      "role": "row"
    }
  }, [_c('td', [_vm._v("Total Consultas")]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.number_format(_vm.totais.consulta, 2, ',', '.')))])]), _vm._v(" "), _c('tr', {
    attrs: {
      "role": "row"
    }
  }, [_c('td', [_vm._v("Valor Excedido")]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.number_format(_vm.totais.excedente, 2, ',', '.')))])]), _vm._v(" "), _c('tr', {
    attrs: {
      "role": "row"
    }
  }, [_c('th', [_vm._v("Total da Fatura")]), _vm._v(" "), _c('th', [_vm._v("---")]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.number_format(_vm.totais.fatura, 2, ',', '.')))])])]), _vm._v(" "), _c('tbody')])], 2)])]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_c('div', {
    staticClass: "text-right",
    staticStyle: {
      "float": "right"
    }
  }, [_c('button', {
    staticClass: "btn btn-default",
    on: {
      "click": function () {
        this$1.$emit('close')
      }
    }
  }, [_vm._v("\n            Fechar\n          ")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary",
    on: {
      "click": _vm.imprime
    }
  }, [_vm._v("\n            Imprimir\n          ")])])])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-58f59055"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/fechamento/Impressao.vue
// module id = 165
// module chunks = 1